(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ji-pdp-block-styles"] && !Shopify.designMode) return;
  try {
    if (!window.jiPdpOpenLinks) {
    window.jiPdpOpenLinks = true;
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[data-ji-open]') : null;
      if (!link) return;
      const id = (link.getAttribute('href') || '').slice(1);
      const target = id ? document.getElementById(id) : null;
      if (target instanceof HTMLDetailsElement) target.open = true;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
